export default {"src":"/_next/static/media/Verified.b25a864d.svg","height":47,"width":33,"blurWidth":0,"blurHeight":0};